import React, { FunctionComponent } from 'react';
import {  getErrorMessageFromAxiosError } from '@companion-professional/webutils';
import { LoaderWithHeader } from '../LoaderWithHeader';
import { ErrorWithHeader } from '../ErrorWithHeader';

interface QueryLoaderWrapperV2Props {
  // isPending is a boolean that indicates whether the query is pending or not.  If it is pending, a loading spinner
  // will be shown.
  isPending?: boolean;

  // error is an Error object that indicates that there was an error with the query.  If there is an error, an error
  // message will be shown.
  error?: Error | null;

  // errorHeading is the heading (the top, bold section) that will be shown in the error message.  Defaults to "Error".
  errorHeading?: string;

  // children is the content that will be shown if there is no error and the query is not pending.
  children?: React.ReactNode;
}

// QueryLoaderWrapper is a component that takes output (isPending and error) from a react-query hook and displays a
// loading spinner, error message or the children of the component.

// This currently needs to be called across all the compoenents to leverage
// consistent behaviour. I would like to refactor it and use better alternative
// to avoid this, and promote consistency as per this ticket: https://app.clickup.com/t/868f64x0d
export const QueryLoaderWrapperV2: FunctionComponent<QueryLoaderWrapperV2Props> = ({
  isPending = false,
  error = null,
  errorHeading = 'Error',
  children
}) => {
  if (isPending) {
    return <LoaderWithHeader />;
  }

  if (error) {
    const message = getErrorMessageFromAxiosError(error);

    return <ErrorWithHeader title={errorHeading} message={message} />;
  }

  return children;
};
